export default {
  "path": "/demo/screen-shot-index",
  "meta": {
    "name": "demo-截图绘制",
    "title": "ScreenShot 截图绘制",
    "isComponentDoc": true,
    "category": "Basic"
  }
};